import * as React from 'react';
import {CONTENT_TYPE} from '../../Config/appConfig';
import AppContainer from './AppContainer';
import {RecordCount} from '../../Config/dataModel';

interface DashboardContainerProps {
    newCount?: RecordCount
}

class DashboardContainer extends React.Component <DashboardContainerProps, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.DASHBOARD} newCount={this.props.newCount}/>
        );
    }
}

export default DashboardContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/DashboardContainer.tsx